import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Badge } from '../components/ui/badge';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';

const Events = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const gallery = [
    {
      image: 'https://customer-assets-rejwkqb3.emergentagent.net/job_6c091b39-7ff2-4a9d-85e6-431bffec44b6/artifacts/iiga292k_dji_fly_20260710_141758_0160_1784042020988_photo%202.webp',
      category: 'Firmenfeier',
      title: 'Sommerfest 2026'
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_event-truck/artifacts/ne9jnzqj_AdobeStock_283732318.jpeg',
      category: 'Hochzeit',
      title: 'Traumhafte Hochzeit im Grünen'
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_event-truck/artifacts/6jwclvdn__NIK4251%20copy.JPG',
      category: 'Firmenfeier',
      title: 'Firmen-Sommerfest 2024'
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_event-truck/artifacts/v9sbmmq7_IMG_4501.JPG',
      category: 'Festival',
      title: 'Street Food Festival'
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_event-truck/artifacts/zn14g2uu_IMG_8840%20copy.JPG',
      category: 'Festival',
      title: 'Stadtfest 2024'
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_event-truck/artifacts/y38x052h_IMG_8100.JPG',
      category: 'Festival',
      title: 'Festival Ulm'
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_event-truck/artifacts/fr4w4evc_156.JPG',
      category: 'Firmenfeier',
      title: 'Sommerfest auf dem Boot'
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_event-truck/artifacts/nwyu5kl0_IMG_9920.jpg',
      category: 'Hochzeit',
      title: 'Elegante Gartenhochzeit'
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_event-truck/artifacts/2wtz02aw_IMG_9496.JPG',
      category: 'Firmenfeier',
      title: 'Weihnachtsfeier 2025'
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_event-truck/artifacts/9o8yr0l1_IMG_0376%20copy.JPG',
      category: 'Geburtstag',
      title: 'Geburtstagsfeier 2024'
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_event-truck/artifacts/ogxlab6r_IMG_8567.JPG',
      category: 'Geburtstag',
      title: 'Geburtstag im Freien'
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_event-truck/artifacts/u6908wyu_IMG_8367.JPG',
      category: 'Geburtstag',
      title: 'Kindergeburtstag 2023'
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_event-truck/artifacts/2eij7c8g_IMG_3708.jpg',
      category: 'Firmenfeier',
      title: 'Sommerfest 2023'
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_event-truck/artifacts/wk5wc8ha_MR-03694%20copy.jpg',
      category: 'Hochzeit',
      title: 'Vintage Hochzeit'
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_event-truck/artifacts/fxt8sj54_IMG_9280%202.JPG',
      category: 'Firmenfeier',
      title: 'Weihnachtsfeier 2024'
    }
  ];

  const eventTypes = [
    {
      title: 'Hochzeiten',
      description: 'Machen Sie Ihren besonderen Tag unvergesslich mit unserem exklusiven Food Truck Catering. Von eleganten Buffets bis zu kreativen Street Food Konzepten.',
      features: ['Individuelle Menü-Gestaltung', 'Elegante Präsentation', 'Service-Personal', 'Getränke-Service'],
      guestRange: '50 - 300 Gäste',
      image: 'https://customer-assets.emergentagent.com/job_event-truck/artifacts/ne9jnzqj_AdobeStock_283732318.jpeg'
    },
    {
      title: 'Firmenfeiern',
      description: 'Beeindrucken Sie Ihre Mitarbeiter und Geschäftspartner mit modernem Event-Catering. Perfekt für Betriebsfeste, Jubiläen und Produktpräsentationen.',
      features: ['Business-Catering', 'Flexible Zeitplanung', 'Professioneller Service', 'Corporate Design möglich'],
      guestRange: '50 - 3000 Gäste',
      image: 'https://customer-assets.emergentagent.com/job_event-truck/artifacts/w6xkdfit_156.JPG'
    },
    {
      title: 'Festivals & Stadtfeste',
      description: 'Wir sorgen für kulinarische Vielfalt auf Ihrem Festival. Mit mehreren Food Trucks gleichzeitig bedienen wir auch große Besucherströme.',
      features: ['Mehrere Trucks gleichzeitig', 'Hohe Kapazitäten', 'Komplette Technik', 'Erfahrenes Festival-Team'],
      guestRange: '500 - 10000+ Besucher',
      image: 'https://images.unsplash.com/photo-1533174072545-7a4b6ad7a6c3?w=600&h=400&fit=crop'
    },
    {
      title: 'Geburtstage & Private Feiern',
      description: 'Ob runder Geburtstag, Gartenparty oder Familienfeier – wir machen Ihre private Feier zu etwas Besonderem mit lockerem Food Truck Ambiente.',
      features: ['Persönliche Beratung', 'Flexible Menüs', 'Deko-Service optional', 'Musik & Entertainment'],
      guestRange: '30 - 200 Gäste',
      image: 'https://customer-assets.emergentagent.com/job_event-truck/artifacts/kr7obt23_IMG_0376%20copy.JPG'
    }
  ];

  const categories = ['Alle', 'Hochzeit', 'Firmenfeier', 'Festival', 'Geburtstag'];
  const [activeCategory, setActiveCategory] = useState('Alle');

  const filteredGallery = activeCategory === 'Alle' 
    ? gallery 
    : gallery.filter(item => item.category === activeCategory);

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative h-[400px] flex items-center justify-center overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: 'url(https://images.unsplash.com/photo-1505236858219-8359eb29e329?w=1920&h=1080&fit=crop)',
            filter: 'brightness(0.4)'
          }}
        />
        <div className="relative z-10 text-center text-white px-4">
          <h1 className="text-5xl md:text-6xl font-bold mb-4">
            Events & <span className="text-red-600">Galerie</span>
          </h1>
          <p className="text-xl md:text-2xl font-light">
            Unsere erfolgreichen Veranstaltungen
          </p>
        </div>
      </section>

      {/* Event Types Section */}
      <section className="py-20 px-4 bg-white">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold mb-4 text-gray-900">
              Unsere <span className="text-red-600">Event-Typen</span>
            </h2>
            <p className="text-xl text-gray-600">
              Für jeden Anlass das perfekte Konzept
            </p>
          </div>
          <div className="space-y-12">
            {eventTypes.map((event, index) => (
              <div 
                key={index}
                className={`grid md:grid-cols-2 gap-8 items-center ${index % 2 === 1 ? 'md:flex-row-reverse' : ''}`}
              >
                <div className={index % 2 === 1 ? 'md:order-2' : ''}>
                  <img
                    src={event.image}
                    alt={event.title}
                    className="rounded-lg shadow-xl w-full"
                  />
                </div>
                <div className={index % 2 === 1 ? 'md:order-1' : ''}>
                  <Badge className="bg-red-600 text-white mb-4">{event.guestRange}</Badge>
                  <h3 className="text-3xl font-bold mb-4 text-gray-900">{event.title}</h3>
                  <p className="text-lg text-gray-600 mb-6">{event.description}</p>
                  <div className="space-y-2">
                    {event.features.map((feature, featureIndex) => (
                      <div key={featureIndex} className="flex items-center gap-2">
                        <div className="w-2 h-2 bg-red-600 rounded-full" />
                        <span className="text-gray-700">{feature}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="py-20 px-4 bg-gray-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold mb-4 text-gray-900">
              Event <span className="text-red-600">Galerie</span>
            </h2>
            <p className="text-xl text-gray-600 mb-8">
              Impressionen unserer erfolgreichen Events
            </p>
            
            {/* Category Filter */}
            <div className="flex flex-wrap justify-center gap-3">
              {categories.map((category) => (
                <Button
                  key={category}
                  onClick={() => setActiveCategory(category)}
                  variant={activeCategory === category ? 'default' : 'outline'}
                  className={activeCategory === category ? 'bg-red-600 hover:bg-red-700' : ''}
                >
                  {category}
                </Button>
              ))}
            </div>
          </div>

          {/* Gallery Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredGallery.map((item, index) => (
              <div
                key={index}
                className="group relative overflow-hidden rounded-lg shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer h-80"
                onClick={() => setSelectedImage(item)}
              >
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                <div className="absolute bottom-0 left-0 right-0 p-6 text-white transform translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                  <Badge className="bg-red-600 mb-2">{item.category}</Badge>
                  <h3 className="text-xl font-bold">{item.title}</h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Statistics Section */}
      <section className="py-20 px-4 bg-red-600 text-white">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-5xl font-bold mb-2">650+</div>
              <div className="text-xl">Erfolgreiche Events</div>
            </div>
            <div>
              <div className="text-5xl font-bold mb-2">50,000+</div>
              <div className="text-xl">Zufriedene Gäste</div>
            </div>
            <div>
              <div className="text-5xl font-bold mb-2">8+</div>
              <div className="text-xl">Jahre Erfahrung</div>
            </div>
            <div>
              <div className="text-5xl font-bold mb-2">98%</div>
              <div className="text-xl">Weiterempfehlung</div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-4 bg-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl font-bold mb-6 text-gray-900">
            Bereit für Ihr <span className="text-red-600">nächstes Event?</span>
          </h2>
          <p className="text-xl text-gray-600 mb-10">
            Lassen Sie uns gemeinsam Ihre Veranstaltung planen
          </p>
          <Link to="/contact">
            <Button size="lg" className="bg-red-600 hover:bg-red-700 text-white px-12 py-6 text-lg">
              Jetzt Angebot anfordern
            </Button>
          </Link>
        </div>
      </section>

      {/* Image Modal */}
      {selectedImage && (
        <div 
          className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
        >
          <div className="max-w-4xl w-full">
            <img
              src={selectedImage.image}
              alt={selectedImage.title}
              className="w-full rounded-lg"
            />
            <div className="text-white text-center mt-4">
              <Badge className="bg-red-600 mb-2">{selectedImage.category}</Badge>
              <h3 className="text-2xl font-bold">{selectedImage.title}</h3>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Events;